import React from 'react';
import { Users, Award, Target, Star } from 'lucide-react';
import roushan from "../assets/raushan.webp";
import soni from "../assets/soni.webp";

function TeamSection() {
    const teamMembers = [
        {
            name: "Raushan Kumar Kashyap",
            role: "Founder & Director",
            image : roushan,
            description: "25+ years in television and media industry. Believes work is about passion and enjoyment. Always ventures outside the box.",
            highlight: "Delivering Perfect & the best is one & only passion."
        },
        {
            name: "Soni Kumar",
            image : soni,

            role: "Co-Founder & Creative Head",
            description: "22+ years experience with innovative ideas and creativity. Has done various TV shows and Hindi Feature Films.",
            highlight: "Knows to see both sides of the coin. Believes perfect video communicates effectively."
        }
    ];

    const teamStats = [
        { icon: <Users size={20} />, label: "Creative Team", value: "50+" },
        { icon: <Award size={20} />, label: "Years Combined", value: "40+" },
        { icon: <Target size={20} />, label: "Successful Projects", value: "500+" },
        { icon: <Star size={20} />, label: "Industry Awards", value: "25+" }
    ];

    return (
        <div className="bg-white py-7 md:pb-20">
            <div className="max-w-7xl mx-auto px-4">
                <div className="text-center max-w-3xl mx-auto mb-12">
                    <span className="inline-block px-4 py-2 bg-gradient-to-r from-emerald-100 to-green-100 text-emerald-700 rounded-full text-sm font-medium mb-4">
                        Our Team
                    </span>
                    <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
                        People{' '}
                        <span className="bg-gradient-to-r from-emerald-600 to-green-600 bg-clip-text text-transparent">
                            Behind The Scene
                        </span>
                    </h2>
                    <p className="text-gray-600">
                        A multidisciplinary team of directors, writers, producers, cinematographers, editors, 
                        animators, composers and designers.
                    </p>
                </div>

                <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mb-12">
                    {teamStats.map((stat, index) => (
                        <div key={index} className="bg-gradient-to-br from-emerald-50 to-green-50 p-6 rounded-xl text-center">
                            <div className="flex justify-center mb-3">
                                <div className="p-2 bg-gradient-to-r from-emerald-500 to-green-500 rounded-lg">
                                    <div className="text-white">{stat.icon}</div>
                                </div>
                            </div>
                            <div className="text-3xl font-bold text-emerald-700 mb-1">{stat.value}</div>
                            <p className="text-sm text-gray-600">{stat.label}</p>
                        </div>
                    ))}
                </div>

                <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
                    {teamMembers.map((member, index) => (
                        <div key={index} className="group relative overflow-hidden rounded-2xl bg-gradient-to-br from-gray-50 to-white border border-gray-100 p-8 hover:border-emerald-200 transition-all duration-300">
                            <div className="space-y-6">
                                <div className="space-y-3">
                                    <div className="flex items-start justify-between">
                                        <div>
                                            <h3 className="text-2xl font-bold text-gray-900">{member.name}</h3>
                                            <p className="text-emerald-600 font-medium mt-1">{member.role}</p>
                                        </div>
                                        <div className="w-20 pt-2 overflow-hidden h-20 bg-gradient-to-r from-emerald-500 to-green-500 rounded-full flex items-center justify-center text-white font-bold">
                                            <img className='relative -top-1' src={member.image} alt={member.name} />
                                        </div>
                                    </div>
                                    <p className="text-gray-600 leading-relaxed">{member.description}</p>
                                    <div className="p-4 bg-gradient-to-r from-emerald-50 to-green-50 rounded-lg border-l-4 border-emerald-500">
                                        <p className="text-emerald-700 italic">{member.highlight}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>

                {/* Join Team CTA */}
                <div className="mt-12 bg-gradient-to-r from-emerald-600 to-green-600 rounded-2xl p-8 text-white">
                    <div className="flex flex-col lg:flex-row items-center justify-between gap-6">
                        <div className="space-y-3">
                            <h3 className="text-2xl font-bold">Join Our Creative Team</h3>
                            <p className="opacity-90">
                                We always look forward to collaborate with creative minds and the best brands. 
                                Drop your portfolios, CV and showreels at raushan@kaanshifilms.com
                            </p>
                        </div>
                        <button className="px-6 py-3 bg-white text-emerald-700 font-semibold rounded-lg hover:bg-gray-100 transition-all duration-300 whitespace-nowrap">
                            Send Your Portfolio
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default TeamSection;